import { render, staticRenderFns } from "./AdsButton.vue?vue&type=template&id=5b010a34&scoped=true&"
import script from "./AdsButton.vue?vue&type=script&lang=js&"
export * from "./AdsButton.vue?vue&type=script&lang=js&"
import style0 from "./AdsButton.vue?vue&type=style&index=0&id=5b010a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b010a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
